module.exports = __webpack_public_path__ + "img/caching.44ae97cc.svg";